import Text from '@components/Text';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import { Trans } from 'react-i18next';

function OrderNote() {
    return (
        <Container >
            <NoteText color={colors.gray7} size='s' align='center'>
                <Trans ns="orderLog" i18nKey="note.pushNotification" components={{ br: <br /> }} />
            </NoteText>
        </Container>
    );
}

const Container = styled.div`
    padding: 16px;
    border-radius: 8px;
    border: 1px solid ${colors.gray2};
    width: calc(100% - 32px);
    margin: 24px 16px 0;
`;

const NoteText = styled(Text)`
    line-height: 1.4;
`;

export default OrderNote;
